// extracted by mini-css-extract-plugin
export var root = "adSn";
export var rootBreadcrumbs = "sRtQ";
export var rootCategory = "_9ms1";
export var rootContainer = "KGbc";
export var rootDescription = "pw7e";
export var rootHeading = "XVT8";